import { createAsyncThunk } from "@reduxjs/toolkit";
import { getcustomerfeedback } from "../../../services/feedbackService";

export const fetchCustomerFeedbackdata = createAsyncThunk(
  "customer/fetchcustomerfeedback",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getcustomerfeedback();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
